import React from 'react';
import TextBox from '../Basic/TextBox';
import * as consts from '../../constants';
export default p => {
  return (
    <TextBox {...p} pattern={consts.REGEX_EMAIL}  patternErrorMsg="Email is invalid"/>
  );
}

